import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Role as Roles } from '@enums/role.enum';
import { RoleGuard } from '@services/role-guard.service';
import { AuthGuard } from '@services/auth-guard.service'
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ReportsComponent } from './reports/reports.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin-configuration/admin-configuration.module').then(m => m.AdminConfigurationModule),
    canActivate: [RoleGuard],
    data: { role: [Roles.SiteAdmin] }
  },
  {
    path: 'reseller',
    loadChildren: () => import('./admin-reseller/admin-reseller.module').then(m => m.AdminResellerModule),
    canActivate: [RoleGuard],
    data: { role: [Roles.SiteAdmin, Roles.Reseller] }
  },
  {
    path: 'admin-business',
    loadChildren: () => import('./admin-business/admin-business.module').then(m => m.AdminBusinessModule),
    canActivate: [RoleGuard],
    data: { role: [Roles.SiteAdmin, Roles.Reseller, Roles.BusinessAdmin, Roles.UserBusiness] }
  },
  {
    path: 'admin-location',
    loadChildren: () => import('./admin-location/admin-location.module').then(m => m.AdminLocationModule),
    canActivate: [RoleGuard],
    data: { role: [Roles.SiteAdmin, Roles.Reseller, Roles.BusinessAdmin, Roles.UserBusiness] }
  },
  {
    path: 'landing-redirect',
    loadChildren: () => import('./landing-redirect/landing-redirect.module').then(m => m.LandingRedirectModule),
    canActivate: [RoleGuard],
    data: { role: [Roles.SiteAdmin, Roles.Reseller, Roles.BusinessAdmin, Roles.UserBusiness] }
  },
  {
    path: 'path-report',
    component: ReportsComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
